import { InfoCircleFilled } from "@ant-design/icons";

import { StatusColorNames, useGetStatusColor } from "@/entities/statuses";

import s from "./menu-styles.module.scss";

interface IndicatorProps {
	statusName: StatusColorNames;
}

export const Indicator = ({ statusName }: IndicatorProps) => {
	const statusColor = useGetStatusColor(statusName);

	return (
		<div className="absolute right-[-8px] top-[6px]">
			<InfoCircleFilled className={s.indicatorIcon} style={{ color: statusColor }} />
		</div>
	);
};
